import { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../../profilesearch.css";
import { useDispatch, useSelector } from "react-redux";
import { searchProfile } from "../../store/slices/preference";
import {
  sendInterest,
  shortlistUser,
} from "../../store/slices/intrestandshortlisted";
import { toast } from "react-toastify";
import {
  sendMessage,
  getConversationByUser,
  getMessages,
} from "../../store/slices/chat";
import { Spinner } from "react-bootstrap";

export default function ProfileSearch() {
  const [showFilter, setShowFilter] = useState(false);
  const dispatch = useDispatch();
  const [activeChatUser, setActiveChatUser] = useState(null);
  const [conversationId, setConversationId] = useState(null);
  const [filter, setFilter] = useState({
    gender: "",
    minAge: "",
    maxAge: "",
    minHeight: "",
    maxHeight: "",
    caste: "",
  });
  const { searchResults = [], searchLoading } = useSelector(
    (state) => state.preference,
  );

  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const [profiles, setProfiles] = useState([]);

  const LIMIT = 10;

  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const [visibleCount, setVisibleCount] = useState(10);
  const [revealedCount, setRevealedCount] = useState(10);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const isLoadingRef = useRef(false);

  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.userId;

  useEffect(() => {
    dispatch(
      searchProfile({
        page,
        limit: LIMIT,
        ...filter,
      })
    );
  }, [dispatch, page, filter]);

  useEffect(() => {
    if (page === 1) {
      setProfiles(searchResults);
    } else {
      setProfiles((prev) => {
        const map = new Map();

        [...prev, ...searchResults].forEach(item => {
          map.set(item._id, item);
        });

        return [...map.values()];
      });
    }

    if (searchResults.length < LIMIT) {
      setHasMore(false);
    } else {
      setHasMore(true);
    }
  }, [searchResults, page]);
  const heightOptions = [
    "4'6\"",
    "4'7\"",
    "4'8\"",
    "4'9\"",
    "4'10\"",
    "4'11\"",
    "5'0\"",
    "5'1\"",
    "5'2\"",
    "5'3\"",
    "5'4\"",
    "5'5\"",
    "5'6\"",
    "5'7\"",
    "5'8\"",
    "5'9\"",
    "5'10\"",
    "5'11\"",
    "6'0\"",
    "6'1\"",
    "6'2\"",
    "6'3\"",
    "6'4\"",
    "6'5\"",
    "6'6\"",
    "6'7\"",
    "6'8\"",
    "6'9\"",
    "6'10\"",
    "6'11\"",
    "7'0\""
  ];

  useEffect(() => {
    const batchStart = revealedCount;
    const batchEnd = visibleCount;
    if (batchStart >= batchEnd) return;

    let current = batchStart;
    const interval = setInterval(() => {
      current += 1;
      setRevealedCount(current);
      if (current >= batchEnd) clearInterval(interval);
    }, 80);

    return () => clearInterval(interval);
  }, [visibleCount]);


  useEffect(() => {
    const handleScroll = () => {
      if (isLoadingRef.current) return;
      if (!hasMore) return;

      const bottom =
        window.innerHeight + window.scrollY >=
        document.documentElement.offsetHeight - 250;

      if (!bottom) return;

      isLoadingRef.current = true;
      setIsLoadingMore(true);

      setPage((prev) => prev + 1);

      setTimeout(() => {
        isLoadingRef.current = false;
        setIsLoadingMore(false);
      }, 500);
    };

    window.addEventListener("scroll", handleScroll);

    return () =>
      window.removeEventListener("scroll", handleScroll);
  }, [hasMore]);
  const navigate = useNavigate();

  const lastScrollY = useRef(0);
  const [fabHidden, setFabHidden] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      setFabHidden(currentY > lastScrollY.current && currentY > 80);
      lastScrollY.current = currentY;
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);



  const activeFilterCount = Object.values(filter).filter(
    (v) => v !== "",
  ).length;

  const resetFilters = () => {
    setFilter({
      gender: "",
      minAge: "",
      maxAge: "",
      minHeight: "",
      maxHeight: "",
      caste: "",
    });

    setProfiles([]);
    setPage(1);
    setHasMore(true);
  };

  const handlesendIntrested = async (userId) => {
    setProfiles((prev) =>
      prev.map((p) =>
        p._id === userId ? { ...p, interestSent: "pending" } : p,
      ),
    );
    try {
      const res = await dispatch(sendInterest({ toUserId: userId })).unwrap();
      if (res?.success) toast.success(res?.message || "Interest sent successfully!");
    } catch (err) {
      setProfiles((prev) =>
        prev.map((p) => (p._id === userId ? { ...p, interestSent: null } : p)),
      );
      toast.error(err || err?.data?.message || "Failed to send interest.");
    }
  };

  const handleShortlisted = async (userId) => {
    setProfiles((prev) =>
      prev.map((p) => (p._id === userId ? { ...p, isShortlisted: true } : p)),
    );
    try {
      const res = await dispatch(shortlistUser({ toUserId: userId })).unwrap();
      if (res?.success) toast.success(res?.message || "User shortlisted successfully!");
    } catch (err) {
      setProfiles((prev) =>
        prev.map((p) =>
          p._id === userId ? { ...p, isShortlisted: false } : p,
        ),
      );
      toast.error(err || err?.data?.message || "Failed to shortlist user.");
    }
  };

  const handleSendMessage = async () => {
    if (!message.trim() || !activeChatUser) return;

    const payload = { toUserId: activeChatUser._id, text: message };
    const tempMsg = { text: message, sender: userId, createdAt: new Date() };

    setMessages((prev) => [...prev, tempMsg]);
    setMessage("");

    try {
      const res = await dispatch(sendMessage(payload)).unwrap();
      if (!res?.data) return;
      setMessages((prev) => [...prev.slice(0, -1), res.data]);
    } catch (err) {
      console.error(err);
    }
  };

  const visibleProfiles = profiles;

  return (
    <>
      <div className="ps-root">
        <div className="ps-header">
          <div className="ps-header-title">Search Results</div>
          <div className="ps-count">
            Showing <strong className="mx-1">{visibleProfiles.length}</strong>
            {/* {" "}
            <strong>{profiles.length}</strong> */}
            compatible profiles
          </div>
        </div>

        <button
          className={`fab-filter-btn ${fabHidden ? "hidden" : ""} ${activeFilterCount > 0 ? "has-filters" : ""}`}
          onClick={() => setShowFilter(!showFilter)}
          aria-label="Filters"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="white"
            strokeWidth="2.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="4" y1="6" x2="20" y2="6" />
            <line x1="6" y1="12" x2="18" y2="12" />
            <line x1="8" y1="18" x2="16" y2="18" />
          </svg>
          <span className="fab-label">Filters</span>
          {activeFilterCount > 0 && (
            <span className="fab-badge">{activeFilterCount}</span>
          )}
        </button>

        <div className="ps-layout">
          <div className={`sp-sidebar ${showFilter ? "active" : ""}`}>
            <div className="filter-card">
              <button className="close-filter" onClick={() => setShowFilter(false)}>
                ✕
              </button>
              <div className="filter-title">Partner Preferences</div>
              <div className="filter-sub">Filter Profiles</div>

              <div className="filter-group">
                <label className="filter-label">Age Range</label>

                <div className="d-flex gap-2">
                  <select
                    className="filter-select"
                    value={filter.minAge}
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        minAge: e.target.value,
                      })
                    }
                  >
                    <option value="">Min Age</option>
                    {Array.from({ length: 43 }, (_, i) => i + 18).map((age) => (
                      <option key={age} value={age}>
                        {age} Years
                      </option>
                    ))}
                  </select>

                  <select
                    className="filter-select"
                    value={filter.maxAge}
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        maxAge: e.target.value,
                      })
                    }
                  >
                    <option value="">Max Age</option>
                    {Array.from({ length: 43 }, (_, i) => i + 18).map((age) => (
                      <option key={age} value={age}>
                        {age} Years
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="filter-group">
                <label className="filter-label">Subcaste</label>
                <select
                  className="filter-select"
                  value={filter.caste}
                  onChange={(e) => setFilter({ ...filter, caste: e.target.value })}
                >
                  <option value="">Any</option>
                  <option value="Sadar">Sadar</option>
                  <option value="Panchamasali">Panchamasali</option>
                  <option value="Banajiga">Banajiga</option>
                </select>
              </div>

              <div className="filter-group">
                <label className="filter-label">Height Range</label>

                <div className="d-flex gap-2">
                  <select
                    className="filter-select"
                    value={filter.minHeight}
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        minHeight: e.target.value,
                      })
                    }
                  >
                    <option value="">Min Height</option>

                    {heightOptions.map((height) => (
                      <option key={height} value={height}>
                        {height}
                      </option>
                    ))}
                  </select>

                  <select
                    className="filter-select"
                    value={filter.maxHeight}
                    onChange={(e) =>
                      setFilter({
                        ...filter,
                        maxHeight: e.target.value,
                      })
                    }
                  >
                    <option value="">Max Height</option>

                    {heightOptions.map((height) => (
                      <option key={height} value={height}>
                        {height}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div
                className="d-flex flex-row justify-content-between"
                style={{ gap: "8px", marginTop: "12px" }}
              >
                <button
                  className="filter-apply"
                  onClick={() => {
                    setProfiles([]);
                    setPage(1);
                    setHasMore(true);
                    setShowFilter(false);
                  }}
                >
                  Apply Filters
                </button>
                <button className="filter-reset" onClick={resetFilters}>
                  ↺ Reset
                </button>
              </div>
            </div>
          </div>

          <div className="ps-main">
            {searchLoading ? (
              Array.from({ length: 4 }).map((_, index) => (
                <div key={index} className="profile-card ep-skeleton-card">
                  <div className="card-photo">
                    <div
                      className="ep-skeleton-circle"
                      style={{ width: "100%", height: "75%", borderRadius: "0" }}
                    />
                  </div>
                  <div className="card-body">
                    <div className="card-top">
                      <div style={{ width: "100%" }}>
                        <div className="ep-skeleton-title" style={{ width: "50%", marginBottom: "8px" }} />
                        <div className="ep-skeleton-line short" style={{ width: "70%" }} />
                      </div>
                    </div>
                    <div className="info-chips" style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginTop: "10px" }}>
                      <div className="ep-skeleton-line" style={{ width: "80px", height: "28px", borderRadius: "20px" }} />
                      <div className="ep-skeleton-line" style={{ width: "90px", height: "28px", borderRadius: "20px" }} />
                      <div className="ep-skeleton-line" style={{ width: "70px", height: "28px", borderRadius: "20px" }} />
                      <div className="ep-skeleton-line" style={{ width: "85px", height: "28px", borderRadius: "20px" }} />
                    </div>
                    <div className="detail-grid" style={{ marginTop: "10px" }}>
                      <div className="detail-item">
                        <div className="ep-skeleton-line" style={{ width: "50%", height: "12px", marginBottom: "6px" }} />
                        <div className="ep-skeleton-line" style={{ width: "70%" }} />
                      </div>
                      <div className="detail-item">
                        <div className="ep-skeleton-line" style={{ width: "55%", height: "12px", marginBottom: "6px" }} />
                        <div className="ep-skeleton-line" style={{ width: "65%" }} />
                      </div>
                    </div>
                    <div className="card-actions" style={{ display: "flex", gap: "8px", marginTop: "12px", flexWrap: "wrap" }}>
                      <div className="ep-skeleton-line" style={{ width: "110px", height: "36px", borderRadius: "6px" }} />
                      <div className="ep-skeleton-line" style={{ width: "90px", height: "36px", borderRadius: "6px" }} />
                      <div className="ep-skeleton-line" style={{ width: "90px", height: "36px", borderRadius: "6px" }} />
                      <div className="ep-skeleton-circle" style={{ width: "36px", height: "36px", borderRadius: "6px" }} />
                    </div>
                  </div>
                </div>
              ))
            ) : profiles.length === 0 ? (
              <div className="filter-card empty-state">
                <div className="empty-icon">🔍</div>
                <div className="empty-text">
                  No profiles match your filters.
                  <br />
                  Try adjusting your preferences.
                </div>
              </div>
            ) : (
              <>
                {visibleProfiles.map((profile, index) => (
                  <div
                    key={profile._id || index}
                    className="profile-card card-animate"
                  >
                    <div className="card-photo position-relative overflow-hidden">
                      <img
                        src={profile.profilePhoto}
                        alt={profile.name}
                        className="img-fluid w-100 h-100 object-fit-cover"
                      />
                      {profile.online && (
                        <div className="online-badge position-absolute">● Online</div>
                      )}
                      {profile.verified && (
                        <div className="verified-badge position-absolute">✓ Verified</div>
                      )}
                    </div>

                    <div className="card-body">
                      <div className="card-top">
                        <div>
                          <div className="card-name">{profile.name}</div>
                          <div className="card-tagline">
                            {profile.age} yrs · {profile?.profile?.height} ·{" "}
                            {profile?.profile?.maritalStatus}
                          </div>
                        </div>
                      </div>

                      <div className="info-chips">
                        <span className="chip">
                          <span className="chip-icon">🎓</span>
                          {profile.education}
                        </span>
                        <span className="chip">
                          <span className="chip-icon">💼 </span>
                          {profile?.occupation}
                        </span>
                        <span className="chip">
                          <span className="chip-icon">📍 </span>
                          {profile.city}
                        </span>
                        <span className="chip">
                          <span className="chip-icon">🗣 </span>
                          {profile?.profile?.motherTongue}
                        </span>
                      </div>

                      <div className="detail-grid">
                        <div className="detail-item">
                          <div className="detail-label">Subcaste</div>
                          <div className="detail-val">{profile?.profile?.subCaste}</div>
                        </div>
                        <div className="detail-item">
                          <div className="detail-label">Annual Income</div>
                          <div className="detail-val">{profile?.profession?.annualIncome}</div>
                        </div>
                      </div>

                      <div className="card-actions">
                        <button
                          className="btn-interest"
                          onClick={() => handlesendIntrested(profile._id)}
                          disabled={profile.interestSent === "pending"}
                        >
                          {profile.interestSent === "pending"
                            ? "Interest Sent ✓"
                            : profile.interestReceived === "pending"
                              ? "Respond to Interest"
                              : "Send Interest"}
                        </button>
                        <button
                          className="btn-view"
                          onClick={() => navigate(`/user/profile-details/${profile._id}`)}
                        >
                          View Profile
                        </button>
                        <button
                          className="btn-shortlist btn-shortlist-off"
                          onClick={() => handleShortlisted(profile._id)}
                          disabled={profile.isShortlisted}
                        >
                          {profile.isShortlisted ? "Shortlisted ✓" : "Shortlist"}
                        </button>
                        <button
                          className="btn-chat"
                          title="Message"
                          onClick={async () => {
                            setActiveChatUser(profile);
                            try {
                              const res = await dispatch(
                                getConversationByUser({ userId: profile._id }),
                              ).unwrap();
                              if (res?.data) {
                                setConversationId(res.data._id);
                                const msgRes = await dispatch(
                                  getMessages({ conversationId: res.data._id }),
                                ).unwrap();
                                setMessages(msgRes?.data || []);
                              } else {
                                setConversationId(null);
                                setMessages([]);
                              }
                            } catch (err) {
                              console.error(err);
                            }
                          }}
                        >
                          💬
                        </button>
                      </div>
                    </div>
                  </div>
                ))}


                {isLoadingMore && visibleCount < profiles.length && (
                  <div style={{ textAlign: "center", padding: "24px" }}>
                    <Spinner animation="border" variant="danger" />
                  </div>
                )}

              </>
            )}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .card-animate {
          animation: fadeUp 0.35s ease-out both;
        }
      `}</style>

      {activeChatUser && (
        <div className="chat-popup">
          <div className="chat-header">
            <span>{activeChatUser.name}</span>
            <button onClick={() => setActiveChatUser(null)}>✕</button>
          </div>
          <div className="chat-body">
            {messages.length === 0 ? (
              <div className="chat-empty">Start conversation...</div>
            ) : (
              messages.map((msg, i) => {
                const senderId = msg?.sender?._id || msg?.sender;
                const isMe = String(senderId).trim() === String(userId).trim();
                return (
                  <div
                    key={msg._id || i}
                    className={`chat-msg ${isMe ? "me" : "other"}`}
                  >
                    {msg.text}
                  </div>
                );
              })
            )}
          </div>
          <div className="chat-footer">
            <input
              type="text"
              placeholder="Type a message..."
              className="chat-input"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSendMessage()}
            />
            <button className="chat-send" onClick={handleSendMessage}>
              Send
            </button>
          </div>
        </div>
      )}
    </>
  );
}